module.exports = __webpack_public_path__ + "static/img/blackLogon.bf45880.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/blackLogon.png
// module id = gtax
// module chunks = 8